import isTouchDevice from "@/utils/isTouchDevice.js";

export default function () {
    if (isTouchDevice()) {
        document.body.classList.add("touch-device");
    } else {
        document.body.classList.add("non-touch-device");
    }
}